// extracted by mini-css-extract-plugin
export default {"licence":"UnlinkedBottomContent__licence--20a0C"};